export function buildAgentRequestUrl(baseUrl, path, { organization, key = '', session = '' }) {
  const url = new URL(baseUrl.replace(/\/?$/, '/') + 'api/agents' + path);
  url.searchParams.set('orgID', organization);
  url.searchParams.set('format', 'data');
  if (key) url.searchParams.set('key', key);
  if (session) url.searchParams.set('session', session);
  return url.toString();
}

export function encodeAgentToken(organization, userId, agentId, runId, messageKind = 'execution') {
  const json = JSON.stringify([1, organization, userId, agentId, runId, messageKind])
    .replace(/[\u007f-\uffff]/g, character => '\\u' + character.charCodeAt(0).toString(16).padStart(4, '0'));
  return btoa(json).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
